import React, { useState } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import InfiniteScrollingGallery from '../../component/InfiniteScrollingGallery';
import {
  MemoryMagnet,
  Frameitforward,
  LegacyMagnet,
  HowKaptaworks, Reviewsmg
} from '../../public/images/home';
import { Plus, Minus } from 'lucide-react';

const Home = () => {
  // State for the "How Kapta Works" accordion
  const [openStep, setOpenStep] = useState(1);

  const toggleStep = (step) => {
    setOpenStep(openStep === step ? null : step);
  };

  const steps = [
    {
      id: 1,
      title: 'Choose what you want to keep',
      description:
        'Start with a photograph, a voice, a message, or a collection of little moments. Pick the keepsake that feels right for your story.',
    },
    {
      id: 2,
      title: 'Share a story behind it',
      description:
        'Upload your story, simple, fast, and intuitive. Add the memory you want your gift to reveal before you complete your purchase.',
    },
    {
      id: 3,
      title: 'We make it meaningful',
      description:
        'Our team carefully crafts your physical keepsake and prepares the digital memory behind the QR code.',
    },
    {
      id: 4,
      title: 'Gift it. Keep it. Pass it on.',
      description:
        'Once your memory is ready, give the gift to yourself or your recipient. The moment becomes emotional, timeless, and deeply personal.',
    },
  ];

  return (
    <div>
      {/* Hero Section */}
     <section className="relative min-h-screen bg-secondary shop-hero flex flex-col">
        <div className="relative z-10 container mx-auto px-4 text-center pt-10 md:pt-14">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-5 leading-tight">
              <span className="block">Where Memories Are</span>
              <span className="block">Kept With Meaning</span>
            </h1>

            <p className="text-lg md:text-xl text-white/90 mb-12 max-w-3xl mx-auto font-light px-4">
              Thoughtfully designed gifts and memory experiences that help you preserve{' '}
              <br className="hidden md:block" /> moments, share stories, and create meaning now and in the future.
            </p>

            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center px-4">
              <a
                href="/shop"
                className="bg-white text-secondary px-6 md:px-10 py-3 md:py-4 font-medium text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 shadow-lg w-full sm:w-auto"
              >
                Explore Memory Gifts
              </a>
              <a
                href="/memoirs"
                className="bg-transparent flex justify-center items-center gap-2 text-white px-6 md:px-10 py-3 md:py-4 font-medium text-lg hover:scale-105 transition-transform w-full sm:w-auto"
              >
                Create a Memoir
                <ArrowRight className="hover:scale-110 transition-transform" color="#ffff" size={20} />
              </a>
            </div>
          </div>
        </div>

        <InfiniteScrollingGallery />
      </section>

      {/* What is Kapta? Section */}
      <section className="bg-[#F9F7EF] py-10 md:py-32 mt-10">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-start mb-16 md:mb-24">
              <h2 className="text-sm w-1/2 md:text-base font-light text-secondary mb-5 flex justify-start items-center gap-2">
                <div className="bg-[#D2A146] w-2 h-2 rounded-full"></div>
                Meet Kapta
              </h2>
              <div className='w-1/2 text-left'>
                <p
                  className="text-[41px] text-secondary font-medium mb-4 leading-relaxed"
                  style={{ lineHeight: '1.2' }}
                >
                  We believe a memory is more than something you look back on. It is a voice, a feeling, a piece of home.
                </p>
                <p className="text-xl text-[#6B635D] font-normal ml-32">
                  Kapta brings those fragments together—thoughtfully shaped into physical and digital keepsakes your family can hold, revisit, and pass on.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#F5EFE4] py-10 md:py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            {/* Header */}
            <div className="flex justify-between items-end mb-3">
              <div>
                <h2 className="text-sm w-1/2 md:text-base font-light text-secondary mb-1 flex justify-start items-center gap-2">
                  <div className="bg-[#D2A146] w-2 h-2 rounded-full"></div>
                  OUR SIGNATURE GIFTS
                </h2>
                <h2 className=' text-secondary font-medium text-[41px]'>Meaningful Gifts for Every Story</h2>
              </div>
              <div>
                <a
                  href="/shop"
                  className="group inline-flex items-center gap-2 text-xl text-[#55000C] font-normal hover:text-[#7a0218] transition-colors"
                >
                  <span className="border-b border-transparent group-hover:border-[#55000C] transition-colors pb-0.5">
                    View all product
                  </span>
                  <ArrowRight
                    size={20}
                    color="#55000C"
                    className="transition-transform duration-300 group-hover:translate-x-1"
                  />
                </a>
              </div>
            </div>

            {/* Products Grid */}
            <div className="flex flex-col md:flex-row gap-6 md:gap-10">
              {/* Memory Magnet */}
              <div className="w-full md:w-1/3">
                <div className="flex flex-col">
                  <div className="mb-4">
                    <img src={MemoryMagnet} alt="Memory Magnet" className="w-full h-[496px] object-cover" />
                  </div>
                  <h3 className="text-xl font-medium text-secondary mb-1 text-left">
                   Custom Memory Magnet
                  </h3>
                  <p className="text-[#6B635D] text-base font-light text-left">
                    A small but powerful keepsake - a magnet that opens a protected digital memory when scanned.
                  </p>
                </div>
              </div>

              {/* Frame it Forward */}
              <div className="w-full md:w-1/3">
                <div className="flex flex-col">
                  <div className="mb-4">
                    <img src={Frameitforward} alt="Frame it Forward" className="w-full h-[496px] object-cover" />
                  </div>
                  <h3 className="text-xl font-medium text-secondary mb-1 text-left">
                    Frame it Forward
                  </h3>
                  <p className="text-[#6B635D] text-base font-light text-left">
                    A timeless frame with a hidden QR code that opens your personal memory.
                  </p>
                </div>
              </div>

              {/* Legacy Magnet */}
              <div className="w-full md:w-1/3">
                <div className="flex flex-col">
                  <div className="mb-4">
                    <img src={LegacyMagnet} alt="Legacy Magnet" className="w-full h-[496px] object-cover" />
                  </div>
                  <h3 className="text-xl font-medium text-secondary mb-1 text-left">
                    Legacy Magnet
                  </h3>
                  <p className="text-[#6B635D] text-base font-light text-left">
                    A beautifully crafted box for birthdays, anniversaries, and intimate celebrations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How Kapta Works Section */}
      <section className="bg-[#18233C]">
        <div className="">
          <div className="flex flex-col lg:flex-row">
            
            {/* Left: Image */}
            <div className="w-full lg:w-1/2 h-full">
              <img 
                src={HowKaptaworks} 
                alt="Woman looking at memory box" 
                className="w-full h-[500px] lg:h-[900px] object-cover object-top"
              />
            </div>

            {/* Right: Accordion Content */}
            <div className="w-full lg:w-1/2 p-6 lg:p-16 text-left flex flex-col justify-center">
              <div className="mb-16 lg:mb-24">
                <h2 className="text-sm md:text-base font-light text-[#D2A146] mb-4 flex items-center gap-2 uppercase tracking-wide">
                  <div className="bg-[#D2A146] w-2 h-2 rounded-full"></div>
                  How Kapta Works
                </h2>
                <h3 className="text-[36px] md:text-[44px] font-bold text-white leading-[1.1] mb-6">
                  A Thoughtful Way to<br className="hidden md:block" /> Preserve What Matters.
                </h3>
              </div>

              <div className="border-t border-white/20">
                {steps.map((step) => {
                  const isOpen = openStep === step.id;
                  return (
                    <div key={step.id} className="border-b border-white/20 py-6">
                      <button
                        onClick={() => toggleStep(step.id)}
                        className="w-full flex items-start gap-6 text-left group focus:outline-none"
                      >
                        <span className="text-[#D2A146] font-medium text-sm mt-1">
                          0{step.id}
                        </span>
                        
                        <div className="flex-1">
                          <div className="flex justify-between items-center">
                            <h4 className="text-lg md:text-xl font-normal text-white group-hover:text-gray-200 transition-colors">
                              {step.title}
                            </h4>
                            <span className="text-white/70 ml-4 flex-shrink-0">
                              {isOpen ? <Minus size={20} strokeWidth={1.5} /> : <Plus size={20} strokeWidth={1.5} />}
                            </span>
                          </div>
                          
                          {/* Expandable description */}
                          <div 
                            className={`grid transition-all duration-300 ease-in-out ${
                              isOpen ? 'grid-rows-[1fr] opacity-100 mt-4' : 'grid-rows-[0fr] opacity-0'
                            }`}
                          >
                            <div className="overflow-hidden">
                              <p className="text-gray-300 text-sm md:text-base leading-relaxed max-w-md">
                                {step.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ─────────────────────────────────────────────────────────
          REDESIGNED REVIEWS SECTION
          ───────────────────────────────────────────────────────── */}
      <section className="bg-[#F9F7EF] py-16 md:py-24">
        <div className="container mx-auto px-4 max-w-[85rem]">
          
          {/* Top Header Row */}
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-12 gap-8">
            <div>
              <h2 className="text-sm md:text-base font-normal text-[#1C2A46] mb-4 flex items-center gap-2">
                <div className="bg-[#D2A146] w-2 h-2 rounded-full"></div>
                REAL MOMENTS SHARED
              </h2>
              <h3 className="text-[40px] md:text-[41px] text-[#1C2A46] leading-[1.1] text-left font-medium">
                One keepsake<br />
                <span className="italic text-[#D2A146] font-serif">A thousand meanings.</span>
              </h3>
            </div>
            
            <div className="lg:max-w-xl pb-2">
              <p className="text-[#6B635D] text-lg font-light text-left leading-relaxed">
                Every photograph carries something different. A voice we miss. A morning we want to remember. A love that has grown with time.
              </p>
            </div>
          </div>

          {/* Split Content Card */}
          <div className="flex flex-col lg:flex-row h-auto lg:h-[650px]">
            
            {/* Left Side: Image */}
            <div className="w-full lg:w-1/2 h-[400px] lg:h-full">
              {/* Using HowKaptaworks as a fallback, replace with your specific image variable */}
              <img 
                src={Reviewsmg} 
                alt="Woman reading a letter" 
                className="w-full h-full object-cover"
              />
            </div>

            {/* Right Side: Quote */}
            <div className="w-full lg:w-1/2 bg-[#1C2A46] p-8 md:p-16 flex flex-col justify-between">
              
              <div className="flex-col flex  gap-4 md:gap-6 mt-8 lg:mt-0 justify-center">
                {/* Big Quote Icon */}
                <svg 
                  className="w-10 h-10 text-[#8A9099] flex-shrink-0 fill-current" 
                  viewBox="0 0 24 24"
                >
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                </svg>
                
                {/* Quote Text */}
                <div className="border-l-4 border-[#8A9099]/40 pl-6 md:pl-8">
                  <p className="text-white text-[24px] md:text-[32px] text-left leading-[1.4] font-light">
                    Dad had a way of turning every family story into a performance. Hearing his voice again, not only seeing his face, made the memory feel close enough to hold.
                  </p>
                </div>
              </div>

              {/* Bottom Author + Navigation */}
              <div className="border-t border-white/20 mt-12 pt-6 flex justify-between items-center">
                <div>
                  <p className="text-white text-xl font-medium mb-1 text-left">Mariam Adibodu</p>
                  <p className="text-gray-400 text-sm font-light text-left">Her father's stories - Lagos</p>
                </div>

                <div className="flex gap-3">
                  <button className="w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 transition-colors flex items-center justify-center">
                    <ArrowLeft size={20} color="#ffffff" />
                  </button>
                  <button className="w-11 h-11 rounded-full bg-white hover:bg-gray-200 transition-colors flex items-center justify-center">
                    <ArrowRight size={20} color="#1C2A46" />
                  </button>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;